import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randNumber } from "@ngneat/falso";

export const randNumberNodeDef = createNodeDef({
  type: "randNumber",
  displayName: "Number",
  defaultName: "number",
  fields: [
    { type: DataFieldType.NUMBER, key: "min", label: "Min" },
    { type: DataFieldType.NUMBER, key: "max", label: "Max" },
    { type: DataFieldType.NUMBER, key: "precision", label: "Precision" },
  ],
  initialData: () => ({ min: 0, max: 999999, precision: undefined }),
  generate: ({ node }) => {
    return randNumber({
      min: node.data.min,
      max: node.data.max,
      precision: Number.isInteger(node.data.precision)
        ? node.data.precision
        : undefined,
    });
  },
});
